import React from 'react';
import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import Modal from '../Modal';
import Grid from '../Grid';
import { TModalWidth } from '../Modal/ModalTypes';
import { RowProps } from '../Grid/GridTypes';

interface DialogProps {
  title: string;
  children?: React.ReactNode;
  disabled?: boolean;
  isOpen: boolean;
  isChildModal?: boolean;
  isLoading?: boolean;
  width?: TModalWidth;
  confirmText?: string;
  refuseText?: string;
  spacing?: RowProps['spacing'];
  portalName?: string;
  onClose?(where: 'btnClose' | 'overlay'): void;
  onConfirm?(): void;
  onRefuse?(): void;
}

function Dialog({
  title,
  children,
  isOpen,
  isChildModal,
  refuseText,
  confirmText,
  isLoading,
  spacing,
  onClose,
  onConfirm,
  onRefuse,
  portalName,
  disabled,
  width,
}: DialogProps) {
  function handleOnConfirm() {
    if (isLoading) {
      return;
    }

    onConfirm?.();
  }

  return (
    <Modal
      isOpen={isOpen}
      hOverlay
      isChildModal={isChildModal}
      width={width}
      showCloseButton
      onClose={(where) => onClose?.(where)}
      portalName={portalName}
    >
      <Grid direction="column" spacing={spacing || 4}>
        <FuelTypography weight="bold" size="heading-sm">
          {title}
        </FuelTypography>

        <div>{children}</div>

        <Grid justify="end" spacing={4} marginTop="km3">
          {onRefuse && (
            <FuelButton
              onClick={() => onRefuse?.()}
              variant="tertiary"
              size="large"
              disabled={disabled}
              data-testid="btn-cancel"
            >
              {refuseText}
            </FuelButton>
          )}
          {onConfirm && (
            <FuelButton
              onClick={() => handleOnConfirm()}
              disabled={disabled}
              size="large"
              isLoading={isLoading}
              data-testid="btn-confirm"
            >
              {confirmText}
            </FuelButton>
          )}
        </Grid>
      </Grid>
    </Modal>
  );
}

export default Dialog;
